module.exports = __webpack_public_path__ + "img/C04TechBowman3_ua.f7eaeb9a.webp";